import $ from 'jquery';
import closeMobileNav from '../mobile-menu/c-mobile-menu';
import closeDesktopNav from '../desktop-menu/c-desktop-menu';

export function showBodyMask() {
    // Define main element and early return
    const $bodyMask = $('.c-body-mask');
    if (!$bodyMask.length) { return; }

    $bodyMask.fadeIn(300);
}

export function hideBodyMask() {
    // Define main element and early return
    const $bodyMask = $('.c-body-mask');
    if (!$bodyMask.length) { return; }

    $bodyMask.fadeOut(300);
}

function initMaskClick() {
    const $bodyMask = $('.c-body-mask');
    if (!$bodyMask.length) { return; }

    // Close things when mask is clicked
    $bodyMask.click(() => {
        closeThingsOnMaskClose();
    });

    // Also trigger the close if mask is hovered for more than half a second
    $bodyMask.on('mouseenter touchstart', () => {
        // IF subnav is already showing, we do the switch staight away, otherwise wait half a sectond to be sure
        setTimeout(() => {
            if ($('.c-body-mask:hover').length) {
                closeThingsOnMaskClose();
            }
        }, 500);
    });
}

function closeThingsOnMaskClose() {
    closeMobileNav();
    closeDesktopNav();
    hideBodyMask();
}

// Kick off the init on document ready
$(() => {
    initMaskClick();
});



// WEBPACK FOOTER //
// ./src/components/body-mask/c-body-mask.js